"use strict";

var _interopRequireDefault = require("/Users/chuongdev/Desktop/project/209web_admin-chung-cu/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.array.push.js");
var _regeneratorRuntime2 = _interopRequireDefault(require("/Users/chuongdev/Desktop/project/209web_admin-chung-cu/node_modules/@babel/runtime/helpers/regeneratorRuntime.js"));
var _asyncToGenerator2 = _interopRequireDefault(require("/Users/chuongdev/Desktop/project/209web_admin-chung-cu/node_modules/@babel/runtime/helpers/asyncToGenerator.js"));
var _objectSpread2 = _interopRequireDefault(require("/Users/chuongdev/Desktop/project/209web_admin-chung-cu/node_modules/@babel/runtime/helpers/objectSpread2.js"));
var _vuex = require("vuex");
var _Breadcrumb = _interopRequireDefault(require("@/components/Breadcrumb"));
var _Hamburger = _interopRequireDefault(require("@/components/Hamburger"));
var _ErrorLog = _interopRequireDefault(require("@/components/ErrorLog"));
var _Screenfull = _interopRequireDefault(require("@/components/Screenfull"));
var _SizeSelect = _interopRequireDefault(require("@/components/SizeSelect"));
var _store = _interopRequireDefault(require("@/store"));
var _jsCookie = _interopRequireDefault(require("js-cookie"));
var _settings = require("@/settings");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = {
  components: {
    Breadcrumb: _Breadcrumb.default,
    Hamburger: _Hamburger.default,
    ErrorLog: _ErrorLog.default,
    Screenfull: _Screenfull.default,
    SizeSelect: _SizeSelect.default
  },
  data: function data() {
    return {
      avatar: "",
      version: _settings.version,
      baseUrlMedia: process.env.VUE_APP_BASE_URL_MEDIA
    };
  },
  mounted: function mounted() {
    this.avatar = _store.default.getters.info.avatar;
  },
  computed: (0, _objectSpread2.default)({}, (0, _vuex.mapGetters)(["sidebar", "device"])),
  methods: {
    changeLang: function changeLang(lang) {
      _jsCookie.default.set("language", lang);
      window.location.reload();
    },
    toggleSideBar: function toggleSideBar() {
      this.$store.dispatch("app/toggleSideBar");
    },
    logout: function logout() {
      var _this = this;
      return (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee() {
        return (0, _regeneratorRuntime2.default)().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _this.$store.dispatch("user/logout");
              case 2:
                _this.$router.push("/auth?redirect=".concat(_this.$route.fullPath));
              case 3:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    }
  }
};
exports.default = _default;